module.exports = __webpack_public_path__ + "img/19Hayes.eb8ebb2f.png";